import { render, staticRenderFns } from "./WalletDetailItem.vue?vue&type=template&id=4928df94&scoped=true&"
import script from "./WalletDetailItem.vue?vue&type=script&lang=js&"
export * from "./WalletDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./WalletDetailItem.vue?vue&type=style&index=0&id=4928df94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4928df94",
  null
  
)

export default component.exports